export default __webpack_public_path__ + "static/media/icon-rating.6929577a.svg";